import { render, staticRenderFns } from "./PaymentMethodsChart.vue?vue&type=template&id=be41b2f6&scoped=true&"
import script from "./PaymentMethodsChart.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodsChart.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodsChart.vue?vue&type=style&index=0&id=be41b2f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be41b2f6",
  null
  
)

export default component.exports